export function imageToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const base64String: any = reader.result as string;
      resolve(base64String);
    };

    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
}

export function replaceLabelValueObjects(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(item => replaceLabelValueObjects(item));
  } else if (obj !== null && typeof obj === 'object') {
    // Check if it's exactly a { label, value } object
    const keys = Object.keys(obj);
    if (
      keys.length === 2 &&
      keys.includes('label') &&
      keys.includes('value') &&
      typeof obj.label === 'string'
    ) {
      return obj.value;
    }

    // Otherwise, recursively process the object
    const newObj: Record<string, any> = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        newObj[key] = replaceLabelValueObjects(obj[key]);
      }
    }
    return newObj;
  }

  return obj; // Return primitive value as-is
}

export const extractPercentageFromLabel = (label: string): number => {
  if (!label || typeof label !== "string" || label.trim() === "") return 0;

  const text = label.toUpperCase().trim();

  // === 1. Look for number + % (most reliable) ===
  const withPercent = text.match(/(\d+(?:\.\d+)?)\s*(?:%|PCT|PERCENT|PER\s*CENT)/);
  if (withPercent) {
    const num = parseFloat(withPercent[1]);
    if (!isNaN(num) && num >= 0 && num <= 500) return num;
  }

  const numberAtEnd = text.match(/.*?(\d+(?:\.\d+)?)\s*$/);
  if (numberAtEnd) {
    const num = parseFloat(numberAtEnd[1]);
    if (!isNaN(num) && num >= 0 && num <= 500) {
      return num; // ← This fixes your case!
    }
  }

  const zeroKeywords = [
    "ZERO", "NIL", "EXEMPT", "EXEMPTED", "NONE",
    "NO VAT", "NOVAT", "NO TAX", "NOTAX",
    "NON-TAXABLE", "NONTAXABLE",
    "EXEMPT SUPPLY", "ZERO RATED", "ZERORATED", "NIL TAX", "NULL"
  ];
  if (zeroKeywords.some(kw => text.includes(kw))) return 0;
  return 0;
};

export const hasIGST = (label: string): boolean => {
  if (!label || typeof label !== "string") return false;
  return label.toUpperCase().includes("IGST");
};

export function extractDocumentNumber(message?: any): string | null {
  try {
    if (typeof message !== "string") return message;

    const match = message?.match(/\b\d{10}([A-Z]{3})?\b/);
    return match?.[0] ?? message;
  }
  catch (err: any) {
    return message
  }
}